/** Unwraps Express/ResponseUtil and axios error bodies for user-visible messages. */
export function getFinanceApiErrorMessage(e: unknown, fallback = 'Request failed'): string {
  const err = e as { response?: { data?: unknown }; message?: string };
  const d = err?.response?.data;
  if (typeof d === 'string') return d;
  if (d && typeof d === 'object') {
    const o = d as Record<string, unknown>;
    if (typeof o.message === 'string') return o.message;
    if (typeof o.error === 'string') return o.error;
  }
  return err?.message ?? fallback;
}
